import { Database } from "lucide-react";

import { MantenedorDeCatalogo } from "@/components/catalogo/MantenedorDeCatalogo";

/**
 * Mantenedor de contextos (pantalla `14 SA` del prototipo).
 *
 * Un contexto es una FUENTE de datos —un documento o una pantalla del
 * sistema— de la que la IA toma información para redactar los inputs de un
 * contenido del informe. Toda la mecánica vive en `MantenedorDeCatalogo`:
 * acá solo van los rótulos, que es lo único que distingue a este catálogo del
 * de ítems de revisión.
 */
export function Contextos() {
  return (
    <MantenedorDeCatalogo
      recurso="contextos"
      singular="contexto"
      plural="contextos"
      icono={Database}
      ejemplo="Certificado de dominio vigente"
      descripcion="Fuentes de las que se toman datos para redactar el informe."
      ayuda={
        <>
          Cada contexto es un documento o una pantalla del sistema que después se vincula
          como fuente de un input de contenido. El orden es el del catálogo y cada contexto
          nuevo se agrega al final. Eliminar uno solo lo saca de la oferta: si vuelves a
          crearlo con el mismo nombre, reaparece en su posición original.
        </>
      }
      vacio={{
        titulo: "El catálogo está vacío",
        descripcion:
          "Agrega el primer contexto con el formulario de arriba: sin fuentes declaradas, la IA no tiene de dónde tomar datos.",
      }}
    />
  );
}
